// extracted by mini-css-extract-plugin
export default {"get_started":"JB","title":"KB","tile_wrapper":"LB","product_use_image":"MB","hub_image":"NB"};
    if(module.hot) {
      // 1743628923629
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  